// extracted by mini-css-extract-plugin
module.exports = {"Page":"TcxhFeedbackDetail_Page__SyuMz"};